module.exports = __webpack_public_path__ + "img/product-6.049c8442.jpg";